import { useNavigate } from 'react-router';
import AppMenuItem from '../ui/AppMenuItem';
import AppMenu from './AppMenu';
import { type SubmenuProps } from './submenu-props';

const GanadoMenu = (props: SubmenuProps) => {
  const navigate = useNavigate();
  const goTo = (route: string) => {
    navigate(route);
    props.onClose();
  };

  return (
    <AppMenu anchorEl={props.anchorElem} open={!!props.anchorElem} onClose={props.onClose}>
      <AppMenuItem module="tipos-ganado" onClick={() => goTo('/tipos-ganado')}>
        Tipos de ganado
      </AppMenuItem>
      <AppMenuItem module="personal-vende" onClick={() => goTo('/personal-vende')}>
        Personal que vende
      </AppMenuItem>
      <AppMenuItem module="personal-recibe" onClick={() => goTo('/personal-recibe')}>
        Personal que recibe
      </AppMenuItem>
      <AppMenuItem module="personal-entrega" onClick={() => goTo('/personal-entrega')}>
        Personal que entrega
      </AppMenuItem>
      <AppMenuItem module="corrales" onClick={() => goTo('/corrales')}>
        Corrales
      </AppMenuItem>
      <AppMenuItem module="precompras" onClick={() => goTo('/pre-compras/registrar')}>
        Pre-Compras
      </AppMenuItem>
      <AppMenuItem module="compras" onClick={() => goTo('/compras')}>
        Compras
      </AppMenuItem>
      <AppMenuItem module="gestion-corrales" onClick={() => goTo('/gestion-corrales')}>
        Gestión de Corrales
      </AppMenuItem>
    </AppMenu>
  );
};

export default GanadoMenu;
